<template>
  <span class="price-base" v-if="canShow">({{ basePrice | price }}/<span v-if="product.baseprice_reference_amount > 1">{{ product.baseprice_reference_amount }}</span>{{ basePriceUnit(product.baseprice_reference_unit) }})</span>
</template>

<script>
import { optionLabel } from '@vue-storefront/core/modules/catalog/helpers';
import rootStore from '@vue-storefront/core/store'

export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    price: {
      type: Number,
      default: 0
    }
  },
  computed: {
    basePrice () {
      return this.price / this.product.baseprice_product_amount
    },
    canShow () {
      return this.price > 0 &&
        this.product.baseprice_product_amount > 0 &&
        this.product.baseprice_reference_unit > 0
    }
  },
  methods: {
    basePriceUnit (unit) {
      return optionLabel(
        rootStore.state.attribute,
        { attributeKey: 'baseprice_reference_unit', optionId: unit }
      )
    }

  }
}
</script>
